/**
 * Collects variant media attach failures from a successful publishListing response.
 * @param {Array} published
 * @returns {Array}
 */
export const collectVariantMediaFailures = (published = []) => (
  published.flatMap((listing) => listing?.variants?.variantMediaFailed || [])
);

/**
 * Maps API variantMediaFailed entries to PublishFailedDialog error rows.
 * @param {Object} failure
 * @returns {{ fieldName?: string, message: string, reason?: string, variantId?: string, assetId?: string }}
 */
export const mapVariantMediaFailureToDialogError = (failure = {}) => ({
  fieldName: failure.assetName || null,
  message: failure.message || 'Variant media could not be attached',
  reason: failure.reason || null,
  variantId: failure.variantId || null,
  assetId: failure.assetId || null,
});

/**
 * Opens a warning dialog when publish succeeded but some variant media failed to attach.
 * @param {Array} published - publishListing response published array
 * @param {{ showPublishFailedDialog: Function }} ui
 * @returns {boolean} true when warnings were shown
 */
const handlePublishVariantMediaWarnings = (published = [], { showPublishFailedDialog }) => {
  const failures = collectVariantMediaFailures(published);

  if (!failures.length) {
    return false;
  }

  showPublishFailedDialog({
    mode: 'warning',
    errors: failures.map(mapVariantMediaFailureToDialogError),
  });

  return true;
};

export default handlePublishVariantMediaWarnings;
